import { IngredientCategory } from "@/lib/types";
import { Badge, BadgeProps } from "../ui/badge";
import { getCategoryLabel, getCategoryColor } from "@/lib/categories";

export function categoryToVariant(
  category: IngredientCategory,
): BadgeProps["variant"] {
  const color = getCategoryColor(category);

  if (color === "gray") {
    return "outline";
  }

  return color;
}

export function CategoryBadge({
  category,
  size = "default",
  className,
}: {
  category: IngredientCategory;
  size?: "sm" | "default";
  className?: string;
}) {
  return (
    <Badge
      variant={categoryToVariant(category)}
      size={size}
      className={className}
    >
      {getCategoryLabel(category)}
    </Badge>
  );
}
